(() => {
  const selector = '[data-codex-comparison]';
  const initialize = scope => scope.querySelectorAll(selector).forEach(stage => {
    if (stage.comparisonController) return;
    const root = stage.closest('.cpc');
    const input = stage.querySelector('.cpc__range');
    if (!root || !input) return;
    const controller = stage.comparisonController = new AbortController();
    const update = () => root.style.setProperty('--cpc-position', input.value + '%');
    input.addEventListener('input', update, { signal: controller.signal });
    update();
  });
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll(selector).forEach(stage => {
    stage.comparisonController?.abort();
    delete stage.comparisonController;
  }));
})();
